import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Button, withStyles } from '@material-ui/core';

import { withTranslation } from 'react-i18next';

class Area extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    console.log('componentDidMount from area');
  }

  handleBack = () => {
    const { activeStep } = this.props.wizard.toJS();
    this.props.wizard.backStep(activeStep);
    this.props.wizard.resetFlow();
  };

  render() {
    const { classes, t } = this.props;
    return (
      <div>
        <Grid item sm={12}>
          <div className={classes.textHeader}>{t('wizard_step_area')}</div>
        </Grid>
        <Grid item xs={12} sm={12} style={{ marginTop: 20 }}>
          <div>coming soon!</div>
        </Grid>
        <Grid container style={{ marginTop: 20, justifyContent: 'space-between' }}>
          <Button variant='outlined' color='primary' onClick={this.handleBack} className={classes.btnPrimary}>
            {t('back')}
          </Button>
          <Button variant='contained' color='primary' onClick={this.handleBack} className={classes.btnPrimary}>
            {t('wizard_finish')}
          </Button>
        </Grid>
      </div>
    );
  }
}

const styles = (theme) => ({
  textHeader: {
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  wrapButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
  },
  btnPrimary: {
    width: 200,
    borderRadius: '4px',
  },
  paperTable: {
    boxShadow: 'none',
    border: '1px solid #B8CFC3',
    borderRadius: '8px',
  },
  tableCellRadio: {
    width: '50px',
    padding: 4,
  },
  btnIcon: {
    width: 32,
    height: 32,
    display: 'flex',
    backgroundColor: theme.palette.primary.bg,
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    fill: theme.palette.primary.main,
    '&:hover': {
      fill: theme.palette.primary.bg,
      backgroundColor: theme.palette.primary.main,
    },
  },
});

export const page = inject('wizard')(observer(Area));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
